module.exports = __webpack_public_path__ + "static/img/chanping17.6582f49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/qqly/chanping17.png
// module id = ymc5
// module chunks = 0